export const reportProfileValidationMap: Record<string, Record<string, string | ((error: any) => string)>> = {
    violations_others: {
        maxlength: (error: any) => `Input text cannot exceed ${error.requiredLength} characters.`,
        required: 'This field is required.',
    },
    violations: {
        required: 'At least one violation must be selected.',
    },
};
